/*
 * - Exposes class and methods to interact with the file storage API
 */

import request, { REQUEST_METHODS } from '@api/Request';
import { FileStorageEndpoints } from './config';
import {
  SearchParams,
  UploadPnAttachmentsRequest,
  DownloadFileResponse,
  DeleteParams,
  DeleteFileResponse,
  GetUserFilesDetailsPayload,
  GetUserFilesDetailsAPIDataResponse,
  GetUserFilesDetailsAPIData,
  UploadRequestFilesRequest,
  UploadFilesResponse,
  UploadAirAttachmentsRequest,
} from './types';

export default class FileStorageService {
  // Queries ---------------------------------------------------------------------------------------
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static readonly getUserFilesDetails = async (params: GetUserFilesDetailsPayload): Promise<any> => {
    const response: GetUserFilesDetailsAPIDataResponse = await request({
      url: FileStorageEndpoints.getUserFilesDetails(),
      method: REQUEST_METHODS.GET,
      params,
    });
    const data = response?.data || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formatData: any[] = [];
    data.forEach((file: GetUserFilesDetailsAPIData) => {
      const tagsObj: { [key: string]: string } = {};
      if (file?.tags?.length) {
        file.tags.forEach((tag: { [key: string]: string }) => {
          if (tag?.key) {
            tagsObj[tag?.key] = tag.value;
          }
        });
      }

      const fileObj = {
        ...tagsObj,
        fileName: file.fileName,
        isUploadedToS3: file.isUploadedToS3,
        fileSize: file.fileSize,
        lastModified: file.lastModified,
      };

      formatData.push(fileObj);
    });

    return formatData || [];
  };

  // Mutations ---------------------------------------------------------------------------------------
  public static readonly uploadRequestFiles = (data: UploadRequestFilesRequest): Promise<UploadFilesResponse> =>
    request({
      url: FileStorageEndpoints.uploadFiles(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly uploadPnAttachments = (data: UploadPnAttachmentsRequest): Promise<UploadFilesResponse> =>
    request({
      url: FileStorageEndpoints.uploadPnAttachments(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly uploadAirAttachments = (data: UploadAirAttachmentsRequest): Promise<UploadFilesResponse> =>
    request({
      url: FileStorageEndpoints.uploadFiles(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly downloadFile = (data: SearchParams): Promise<DownloadFileResponse> =>
    request({
      url: FileStorageEndpoints.downloadFile(),
      method: REQUEST_METHODS.GET,
      responseType: 'blob',
      params: { ...data },
    });
  public static readonly deleteFile = (data: DeleteParams): Promise<DeleteFileResponse> =>
    request({
      url: FileStorageEndpoints.deleteFile(),
      method: REQUEST_METHODS.DELETE,
      params: { ...data },
    });
}
